export const facebook = {
	name: 'facebook',
	title: 'Facebook',
	content:
		'<path d="M18.13,7.75H13.87V5.84a1,1,0,0,1,1-1.1h3v-4H13.54c-3.93,0-4.67,3-4.67,4.86V7.75h-3v4h3v11.5h5V11.75h3.85Z" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"></path>',
};
